import { render, staticRenderFns } from "./LayoutFolderSelect.vue?vue&type=template&id=40a1893e&scoped=true"
import script from "./LayoutFolderSelect.vue?vue&type=script&lang=js"
export * from "./LayoutFolderSelect.vue?vue&type=script&lang=js"
import style0 from "./LayoutFolderSelect.vue?vue&type=style&index=0&id=40a1893e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a1893e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a1893e')) {
      api.createRecord('40a1893e', component.options)
    } else {
      api.reload('40a1893e', component.options)
    }
    module.hot.accept("./LayoutFolderSelect.vue?vue&type=template&id=40a1893e&scoped=true", function () {
      api.rerender('40a1893e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/LayoutFolderSelect.vue"
export default component.exports